import axios from "axios";

function resolveApiBaseUrl() {
  if (typeof window !== "undefined") {
    const envUrl = process.env.REACT_APP_BACKEND_URL;
    if (!envUrl || envUrl === "undefined" || envUrl === "null" || envUrl.trim() === "") {
      return "/api";
    }
    try {
      if (envUrl.startsWith("http://") || envUrl.startsWith("https://")) {
        const parsed = new URL(envUrl);
        if (parsed.origin !== window.location.origin) {
          return "/api";
        }
      }
    } catch {
      return "/api";
    }
  }
  return "/api";
}

export const API = resolveApiBaseUrl();
export const SITE_URL = process.env.REACT_APP_SITE_URL || (typeof window !== "undefined" ? window.location.origin : "");

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(errOrDetail) {
  if (!errOrDetail) return "Algo salió mal. Inténtalo de nuevo.";
  if (typeof errOrDetail === "object") {
    if (errOrDetail.response?.data?.detail) {
      return formatApiError(errOrDetail.response.data.detail);
    }
    if (errOrDetail.response?.data?.message) {
      return String(errOrDetail.response.data.message);
    }
    if (errOrDetail.message) {
      if (errOrDetail.message === "Network Error") {
        return "Error de conexión. Por favor verifica tu red e inténtalo de nuevo.";
      }
      return errOrDetail.message;
    }
  }
  const detail = errOrDetail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function youtubeEmbed(url) {
  if (!url) return null;
  let id = null;
  const m1 = url.match(/[?&]v=([^&]+)/);
  const m2 = url.match(/youtu\.be\/([^?&]+)/);
  const m3 = url.match(/embed\/([^?&]+)/);
  if (m1) id = m1[1];
  else if (m2) id = m2[1];
  else if (m3) id = m3[1];
  if (id) return `https://www.youtube.com/embed/${id}?autoplay=1&rel=0`;
  return url;
}

// Soporta YouTube y Vimeo (el admin puede pegar un enlace de Vimeo si no está en YouTube)
export function videoEmbed(url) {
  if (!url) return null;
  if (/vimeo\.com/.test(url)) {
    const m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (m) return `https://player.vimeo.com/video/${m[1]}?autoplay=1`;
    return url;
  }
  return youtubeEmbed(url);
}

// URL indexable para personas/actores/actrices/directores: /actriz/patricia-tamayo o /persona/patricia-tamayo
export function personPath(id, name) {
  const cleanName = name || (typeof id === "string" && isNaN(Number(id)) ? id : "");
  const slug = cleanName
    .toLowerCase()
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");

  if (slug && id && !isNaN(Number(id))) {
    return `/actriz/${slug}-${id}`;
  }
  if (slug) {
    return `/actriz/${slug}`;
  }
  return `/persona/${id || "1"}`;
}

export function parsePersonId(param) {
  if (!param) return "";
  return decodeURIComponent(param);
}
